<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 overview-icon profile-section">
    <div class="">
      <div class="breadcrumbs-section ">
        <span class="prev-page pt-1 " routerLink="/parkite-overview">Home</span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">Profile</span>
      </div>
    </div>

    <div class="accor-padding-left" *ngIf="showCoAdmin">
      <div class="row pb-3">
        <div class="col-10 profile">
          Profile
        </div>
        <div class="col-2 log-out pointer-link" (click)="logout()">
          Log Out
        </div>
      </div>

      <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent to prevent blank page issues -->
      <ngb-accordion class="accordian-panel " [closeOthers]="true" activeIds="{{activeToggle}}">
        <!-- Admin Section -->
        <div class="accordion-sub-data pl-4 pr-4 pb-4">
          <div class="col-12 row d-flex ">

            <div class="col-4 flex-column ">
              <div class="d-flex flex-column">
                <span class="name">
                  Name
                </span>

                <span class="details">
                  {{taDetails?.name}}
                </span>
              </div>

              <div class="d-flex flex-column pt-5 white-space">
                <span class="name">
                  Mobile Number
                </span>
                <span class="details">
                  <span *ngIf="taDetails?.mobileNumber?.length<=10">+91-</span>{{taDetails?.mobileNumber}}
                </span>
              </div>
            </div>
            <div class="col-4 flex-column ">
              <div class="d-flex flex-column white-space">
                <span class="name">

                  Email ID
                </span>
                <span class="details">

                  {{taDetails?.emailId | lowercase}}
                </span>
              </div>

              <div class="d-flex flex-column pt-4 white-space">
                <span class="name">
                  Department
                </span>
                <span class="details">
                  {{taDetails?.department}}
                </span>
              </div>

            </div>

            <div class="col-4 d-flex justify-content-end">
              <div class="circle-image-position" style="margin-top: 9px;">
                <div class="circle">
                  <div class="circle-name">{{initials}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Co-Admin Sections -->
        <!-- <div *ngFor="let item of parkiteCoadminList;let i=index"
          class="accordion-sub-data pl-4 pr-4 pb-4 pt-0 border-top border-light">
          <div>
            <div *ngIf="item.id==null||item.id==undefined||isEdit">
              <div class="row">
                <div class="col-10">
                  <div class="d-flex   mt-4">
                    <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                      [class.error-input]="fieldErrors.includes('name')" class="search-line  pl-4 placeholder-text"
                      [(ngModel)]="item.fullname" [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name1')"
                      (blur)="enterName('name1')" pattern="^[a-zA-Z ]{2,50}$" required
                      (ngModelChange)="inputModelChange(item.id,'name')" [name]="'fullname_'+i">
                    <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>
                    <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                      [class.error-input]="fieldErrors.includes('email')" class="search-line  pl-4 placeholder-text"
                      [(ngModel)]="item.emailId" [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email1')"
                      (blur)="enterName('email1')" [name]="'email_'+i"
                      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" required
                      (ngModelChange)="inputModelChange(item.id, 'email')">
                    <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                  </div>
                  <div class="row" *ngIf="fieldErrors.length > 0">
                    <div class="col-5 field-error"><span *ngIf="fieldErrors.includes('name')">Please enter valid
                        name</span>
                      <span *ngIf="fieldErrors.includes('name1len')">Please enter not more
                        than 50 characters</span>
                    </div>
                    <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('email')">Please enter
                        valid
                        email</span> </div>
                  </div>
                  <div class="d-flex   mt-4">
                    <input type="tel" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                      class="search-line  pl-4 placeholder-text" [(ngModel)]="item.phoneNumber"
                      [placeholder]="!mobile ? 'Mobile Number' : ''" (click)="enterName('mobile1')"
                      (blur)="enterName('mobile1')" pattern="^\d{10}$"
                      (ngModelChange)="inputModelChange(item.id, 'phone')" [name]="'mobile_'+i"
                      [class.error-input]="fieldErrors.includes('phone')" maxlength="10" required>
                    <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                    <div class="textbox-style pointer-link" style="position: relative;">
                      <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent"
                        triggers="manual" #p="ngbPopover" (click)="openPopover(p);enterName('department')"
                        placement="bottom" popoverClass='dash-popover dashboard-popover'>
                        <input class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link"
                          [placeholder]="!dept ? 'Department' : ''" readonly [(ngModel)]="departmentName" required
                          [class.error-input-dept]="fieldErrors.includes('dept1')" [name]="'dept_'+i">
                        <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1" loading="lazy" />
                      </div>
                      <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                      <div>

                        <ng-template #popContent>
                          <div class="template p-0 m-0">
                            <div class="popupHeader">
                              <img src="../../assets/images/search.png">
                              <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                            </div>
                            <div class="dashboard-popover ">
                              <div class="d-flex justify-content-between">
                                <div class="pl-3 pt-3 pr-3 pb-3 ">
                                  <div class="row pb-2"
                                    *ngFor="let dept of deptList | ListFilter: searchDept;let index =i"
                                    (click)="setDepartmentName(dept.id,i);openPopover(p);inputModelChange(item.id, 'dept');enterName('department')">
                                    <div class="popover-content normal-font pl-3 email-width">
                                      {{dept.department}}
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="fieldErrors.length > 0">
                    <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('phone')">Please enter
                        valid
                        mobile number</span>
                    </div>
                    <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('dept')">Please select a
                        department</span>
                    </div>
                  </div>
                </div>
                <div class="col-2" style="margin: auto;">
                  <div class="profil-pic-holder" [style.background-color]="initials1 == '' ? '#fff': '#d2edf0'">
                    <img *ngIf="initials1 == ''" [src]="'/assets/images/profile/default-user.png'"
                      alt="coadmin profile image">
                    <div class="profil-pic-initial">
                      <span *ngIf="initials1 != ''">{{initials1}}</span>
                    </div>
                  </div>
                </div>
              </div>


              <div class="">
                <div class="line "></div>
              </div>
              <div>
                <div class="pt-4" *ngIf="item.id==null||item.id==undefined||isEdit">
                  <span>
                    <button type="button " [disabled]="disableAdd" class="add-button"
                      (click)="addClick('add', item?.id)"><span class="add">Save</span></button>
                  </span>
                  <button type="button " class="cancel-button pl-3" (click)="cancelAdmin(1)"><span
                      class="cancel">Cancel</span></button>
                </div>
              </div>

            </div>

            <div *ngIf="item.id!==null&&item.id!==undefined&&!isEdit">
              <div class="row">
                <div class="col-10">
                  <div class="row d-flex ml-1">
                    <div class="col-4 d-flex flex-column">
                      <span class="name">
                        Co-Admin Name
                      </span>
                      <span class="details">
                        {{item?.fullname|titlecase}}
                      </span>
                    </div>
                    <div class="col-7 d-flex flex-column">
                      <span class="name">
                        Email Id
                      </span>
                      <span class="details">
                        {{item?.emailId | lowercase}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>

                  <div class="row ml-1">
                    <div class="col-4 d-flex flex-column pt-5  white-space">
                      <span class="name">
                        Mobile Number
                      </span>
                      <span class="details">
                        +91-{{item?.phoneNumber}}
                      </span>
                    </div>
                    <div class="col-7 d-flex flex-column pt-5 ">
                      <span class="name">
                        Department
                      </span>
                      <span class="details">
                        {{getDepartmentName(item?.departmentId)}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>

                <div class="col-2" style="margin: auto;">
                  <div class="profil-pic-holder" [style.background-color]="item.initials == '' ? '#fff': '#d2edf0'">
                    <img *ngIf="item.initials == ''" [src]="'/assets/images/profile/default-user.png'"
                      alt="coadmin profile image">
                    <div class="profil-pic-initial">
                      <span *ngIf="item.initials != ''">{{item.initials}}</span>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="" *ngIf="isAdmin==true">
                    <div class="line "></div>
                  </div>
                  <div class="pt-4" *ngIf="isAdmin==true">
                    <span>
                      <button type="button " class="add-button btn" (click)="addClick('edit', item?.id);"><span
                          class="add">Edit</span></button>
                    </span>
                    <button type="button " class="cancel-button pl-3"
                      (click)="drawerClick(null); removeCoAdmin(item?.id)"><span class="cancel">Remove Co-Admin
                        {{i+1}}</span></button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div> -->
      </ngb-accordion>



      <!-- <div class="row mt-2" *ngIf="isAdmin==true">
        <div class="col-9"></div>
        <div class="col-3">
          <button (click)="addNewCoadmin()" class="add-another-button">Add another Co-Admin</button>
        </div>
      </div> -->


    </div>
  </div>
</div>